import { CademyError, ValidationError } from '@shared/domain-shared';
import Link from 'next/link';
import { FunctionComponent, useEffect, useRef } from 'react';
import Alert from '../../../Alert';

export type FormErrorProps = {
    error: CademyError | null;
    fieldMap: {
        [fieldName: string]: {
            label: string;
            id: string;
        };
    };
};

export const FormError: FunctionComponent<FormErrorProps> = ({ error, fieldMap }) => {
    const alertRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (alertRef.current) {
            alertRef.current.focus();
            alertRef.current.scrollIntoView();
        }
    }, [error]);
    if (!error) {
        return null;
    }
    if (error instanceof ValidationError) {
        const errorItems = error.properties.map((property) => {
            const mappedData = fieldMap[property.key];
            if (!mappedData) {
                return <span key={property.key}>{property.message}</span>;
            }
            return (
                <Link key={property.key} href={`#${mappedData.id}`}>
                    {mappedData.label}: {property.message}
                </Link>
            );
        });
        return (
            <Alert preset="danger" ref={alertRef}>
                {error.title}
                <ul>
                    {errorItems.map((ErrorItem, index) => {
                        return <li key={index}>{ErrorItem}</li>;
                    })}
                </ul>
            </Alert>
        );
    }
    return (
        <Alert preset="danger" ref={alertRef}>
            {error.title}: {error.detail}
        </Alert>
    );
};
